import './index.scss';

const Link = (props: any) => {
  const { children, ...other } = props;
  return <a {...other}>{children}</a>;
};

export default Link;
